import { CardType } from 'types/deck'

export const checkIsCommander = (card: CardType) => {
  const cardSuperTypes = [...card.superTypes, ...(card.front?.superTypes || [])]
  const cardTypes = [...card.types, ...(card.front?.types || [])]

  return (
    (cardSuperTypes.includes('Legendary') && cardTypes.includes('Creature')) ||
    (card.text || card.front?.text || '').includes('can be your commander')
  )
}
